import screeningListReducer from "./screeningListReducer";

const screeningPrintReducers = {
    screeningList: screeningListReducer
};

export default screeningPrintReducers;